import React from 'react';

const variants = {
    error: {
        container: 'bg-red-50 border-red-200 text-red-800',
        icon: 'text-red-500',
    },
    success: {
        container: 'bg-emerald-50 border-emerald-200 text-emerald-800',
        icon: 'text-emerald-500',
    },
    warning: {
        container: 'bg-amber-50 border-amber-200 text-amber-800',
        icon: 'text-amber-500',
    },
    info: {
        container: 'bg-blue-50 border-blue-200 text-blue-800',
        icon: 'text-blue-500',
    },
};

const icons = {
    error: 'M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z',
    success: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    warning: 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126z',
    info: 'M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z',
};

export default function Alert({
    children,
    variant = 'info',
    onClose,
    className = '',
}) {
    const style = variants[variant] || variants.info;

    return (
        <div className={`flex items-start gap-3 rounded-lg border px-4 py-3 text-sm ${style.container} ${className}`}>
            <svg className={`h-5 w-5 shrink-0 mt-0.5 ${style.icon}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d={icons[variant] || icons.info} />
            </svg>
            <div className="flex-1 min-w-0">{children}</div>
            {onClose && (
                <button onClick={onClose} className="shrink-0 rounded p-0.5 hover:bg-black/5 transition-colors">
                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            )}
        </div>
    );
}
